import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { EditSpacerComponent } from 'src/app/components/edit-spacer/edit-spacer.component';
import { EditGlassComponent } from 'src/app/components/edit-glass/edit-glass.component';
import { EditWindowTypeComponent } from 'src/app/components/edit-window-type/edit-window-type.component';
import { EditGeorgianBarsComponent } from 'src/app/components/edit-georgian-bars/edit-georgian-bars.component';
import { StorageService } from 'src/app/services/storage.service';
import { EditFrameComponent } from 'src/app/components/edit-frame/edit-frame.component';
import { calcDeltaUw, calculateAreaWeightedUf, calculateFrameArea, extractFrameWidths, WindowDimensions } from 'src/app/utils/calculation';
import { roundTwoValuePositions } from 'src/app/utils/Constants';
import { ActionComponent } from 'src/app/components/action/action.component';
import { TranslateService } from '@ngx-translate/core';
import * as Constants from "../../utils/Constants";
import { ActivatedRoute } from '@angular/router';
import { MasterdataApiService } from 'src/app/services/masterdata-api.service';
import { ThermalApiService } from 'src/app/services/thermal-api.service';
import { SpacerApiService } from 'src/app/services/spacer-api.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.page.html',
  styleUrls: ['./configuration.page.scss'],
  standalone: false,
})
export class ConfigurationPage implements OnInit {
  @Input() isComparisonMode: boolean = false;
  configType: string = '';
  selectedOption: string = '';
  projectData: any = null;
  resCalcDeltaUw: any;
  allConfig: boolean = false;
  windowType: boolean = false;
  glassType: boolean = false;
  frameType: boolean = false;
  spacerType: boolean = false;
  georgianType: boolean = false;
  saveOnlyGlass: boolean = false;
  masterData: any;
  configStatus: 'NOT_SAVED' | 'UNSAVED_CHANGES' | 'SAVED' = 'NOT_SAVED';
  private configStatusSub?: Subscription;
  constructor(private modalController: ModalController, private storageService: StorageService, private translate: TranslateService, private route: ActivatedRoute,
    private masterdataApi: MasterdataApiService, private thermalApi: ThermalApiService, private spacerApi: SpacerApiService
  ) {
    this.configType = this.route.snapshot.queryParamMap.get('configType') || '';
  }

  ngOnInit() {
    console.log("configType:: ", this.configType)
    this.loadPagedetailsAccordingToSelection();

    console.log(this.allConfig)
    this.loadProjectData();
  }
  openMenu() { }

  async ionViewWillEnter() {
    this.configType = this.route.snapshot.queryParamMap.get('configType') || '';
    this.configStatus = this.storageService.getConfigStatus();
    this.configStatusSub = this.storageService.configStatus$.subscribe(status => {
      this.configStatus = status;
    });
    console.log("Config status", this.configStatus);
    console.log("loaded from here")
    this.loadPagedetailsAccordingToSelection();
    await this.loadProjectData();
    this.masterData = await this.masterdataApi.getCachedMasterData();
    if ((this.isComparisonMode || !this.projectData?.id) && !this.projectData?.saveOnlyGlass) this.fetchThermalResults();
  }

  async loadProjectData() {
    try {
      const storageKey = this.isComparisonMode ? 'compared' : 'main';
      let res = this.isComparisonMode
        ? await this.storageService.getComparedProject()
        : await this.storageService.getProject();

      // Auto-initialize compared project if doesn't exist
      if (this.isComparisonMode && !res) {
        this.storageService.saveComparedProject();
        res = await this.storageService.getComparedProject();
      }
      this.configStatus = this.storageService.getConfigStatus();
      this.configStatusSub = this.storageService.configStatus$.subscribe(status => {
        this.configStatus = status;
      });
      console.log("Config status", this.configStatus);
      this.projectData = res ? JSON.parse(res) : null;
      console.log(`Loaded ${storageKey} project:`, this.projectData);

      if (this.projectData) {
        this.saveOnlyGlass = this.projectData?.saveOnlyGlass;
        if (this.saveOnlyGlass)
          this.resCalcDeltaUw = roundTwoValuePositions(calcDeltaUw(this.projectData));
      }
    } catch (error) {
      console.error('Error loading project data:', error);
    }
  }

  loadPagedetailsAccordingToSelection() {
    if (this.configType != "") {
      let checkVal = this.configType.split("-");
      if (checkVal[0] == 'entire') {
        this.makeAllConfigInactive();
        this.allConfig = true;
      } else {
        if (this.configType == Constants.GLASS_ONLY) {
          this.makeAllConfigInactive();
          this.glassType = true;
        }
      }
    } else {
      this.makeAllConfigInactive();
      this.allConfig = true;
    }
  }

  async openWindowTypeModal() {
    const modal = await this.modalController.create({
      component: EditWindowTypeComponent,
      cssClass: 'configuration-modal',
      componentProps: {
        isComparisonMode: this.isComparisonMode
      }
    });

    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      // console.log('Selected option:', data.selectedOption);
      await this.loadProjectData();
      this.fetchThermalResults();
    }
  }

  async openFrameModal() {
    const modal = await this.modalController.create({
      component: EditFrameComponent,
      cssClass: 'configuration-modal',
      componentProps: {
        isComparisonMode: this.isComparisonMode
      }
    });
    await modal.present();
    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      console.log('Frame selected:', data);
      await this.loadProjectData();
      this.fetchThermalResults();
    }
  }

  getFrameTitle(): string {
    const frame = this.projectData?.windowframe;
    if (!frame) return '';

    // By-brand: Show manufacturer + system name
    if (frame.system) {
      return frame.name || this.translate.instant(frame.type);
    }

    // By-frame or Manual with identical: Show name or translated type
    if (frame.name) {
      return frame.name;
    }

    return this.translate.instant(frame.type);
  }

  getFrameWeightedUf(): number {
    const frame = this.projectData?.windowframe;
    if (!frame) return 0;

    // Check if it's a by-brand or manual non-identical frame (has individual uf values)
    const hasIndividualValues = frame.system || this.hasNonIdenticalUfValues(frame);

    if (!hasIndividualValues) {
      return parseFloat(frame.uf) || 0;
    }

    // area-weighted calculation
    const windowTypeId = parseInt(this.projectData?.windowtype || 1);
    const dimensions: WindowDimensions = {
      a: parseFloat(this.projectData?.dimensions?.a || 0),
      b: parseFloat(this.projectData?.dimensions?.b || 0),
      c: parseFloat(this.projectData?.dimensions?.c || 0)
    };
    const frameWidths = extractFrameWidths(frame);
    const ufValues: number[] = frame.ufValues ??
      Array.from({ length: 7 }, (_, i) => parseFloat(frame[`uf${i}`] || 0));

    return calculateAreaWeightedUf(windowTypeId, dimensions, frameWidths, ufValues);
  }

  private hasNonIdenticalUfValues(frame: any): boolean {
    const ufValues: number[] = frame.ufValues
      ?? Array.from({ length: 7 }, (_: any, i: number) => frame[`uf${i}`] ?? 0);
    const firstUf = ufValues[0];
    return ufValues.slice(1).some(v => v !== firstUf && v !== 0);
  }

  getFrameArea(): number {
    const frame = this.projectData?.windowframe;
    if (!frame) return 0;

    const windowTypeId: number = parseInt(this.projectData?.windowtype || 1);

    const dimensions: WindowDimensions = {
      a: parseFloat(this.projectData?.dimensions?.a || 0),
      b: parseFloat(this.projectData?.dimensions?.b || 0),
      c: parseFloat(this.projectData?.dimensions?.c || 0)
    };

    const frameWidths = extractFrameWidths(frame);

    return calculateFrameArea(windowTypeId, dimensions, frameWidths);
  }

  getFrameImage(): string {
    const type = this.projectData?.windowframe?.type;
    const imageMap: { [key: string]: string } = {
      'FRAME_TYPE_WOOD': 'assets/images/frame/Wood.svg',
      'FRAME_TYPE_PVC': 'assets/images/frame/pvc.svg',
      'FRAME_TYPE_ALU_WOOD': 'assets/images/frame/Aluwood.svg',
      'FRAME_TYPE_ALU_METAL': 'assets/images/frame/Alumetal.svg'
    };
    return imageMap[type] || 'assets/images/frame/pvc.svg';
  }

  shouldShowFrameWidth(): boolean {
    const frame = this.projectData?.windowframe;
    if (!frame) return false;

    // Show width only if it's NOT a by-brand frame and NOT non-identical manual
    return !frame.system && !this.hasNonIdenticalUfValues(frame);
  }

  shouldShowFrameArea(): boolean {
    const frame = this.projectData?.windowframe;
    if (!frame) return false;

    // Show area only if it's a by-brand frame OR non-identical manual
    return !!(frame.system || this.hasNonIdenticalUfValues(frame));
  }

  async openSpacerModal() {
    await this.spacerApi.fetchAndUpdateSpacers().toPromise()
      .catch(err => console.error('Spacer psi fetch failed:', err));
    const modal = await this.modalController.create({
      component: EditSpacerComponent,
      cssClass: 'configuration-modal',
      componentProps: {
        isComparisonMode: this.isComparisonMode
      }
    });

    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      await this.loadProjectData();
      this.fetchThermalResults();
    }
  }

  async openGlassTypeModal() {
    const modal = await this.modalController.create({
      component: EditGlassComponent,
      cssClass: 'configuration-modal',
      componentProps: {
        isComparisonMode: this.isComparisonMode
      }
    });

    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      await this.loadProjectData();
      this.fetchThermalResults();
    }
  }
  getGlassImage(glazingCount?: number): string {
    const map: Record<number, string> = {
      1: 'assets/images/typen/Double.svg',
      2: 'assets/images/typen/Double.svg',
      3: 'assets/images/typen/Triple.svg',
      4: 'assets/images/typen/Quadruple.svg',
    };
    if (!glazingCount) {
      return 'assets/images/glass/default.png';
    }
    return map[glazingCount] || 'assets/images/glass/default.png';
  }


  async openGeorgianBarsModal() {
    const modal = await this.modalController.create({
      component: EditGeorgianBarsComponent,
      cssClass: 'configuration-modal',
      componentProps: {
        isComparisonMode: this.isComparisonMode
      }
    });

    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      await this.loadProjectData();
      this.fetchThermalResults();
    }
  }

  getConfigurationSummary(): string {
    if (!this.projectData) return '';

    const parts: string[] = [];

    // Window type name
    if (this.mappedWindowType?.name) {
      parts.push(this.getWindowTypeName());
    }

    // Frame type (if available)
    if (this.projectData.windowframe?.type) {
      parts.push(this.translate.instant(this.projectData.windowframe.type));
    }

    // Glass structure
    if (this.projectData.windowglas?.structure) {
      parts.push(this.projectData.windowglas.structure);
    }

    // Spacer name
    if (this.projectData.spacer?.name) {
      parts.push(this.projectData.spacer.name);
    }

    // if (this.projectData.windowGlassBrandSettings?.countryId !== undefined) {
    //   parts.push('GB');
    // }

    return parts.join(' - ');
  }

  get mappedWindowSpacer(): any {
    const id = this.projectData?.spacer?.id;
    if (id == null) return null;
    if (id == 0) return this.projectData?.spacer;
    return this.masterData?.spacers?.find((w: any) => w.id == id) ?? null;
  }

  get mappedGeorgianBarShape(): any {
    const id = this.projectData?.muntin?.shape?.id;
    if (id == null) return null;
    if (id == -1) return this.projectData?.muntin;
    // console.log(Constants.data_muntin_shapes?.find((w: any) => w.id == id) ?? null)
    return Constants.data_muntin_shapes?.find((w: any) => w.id == id) ?? null;
  }

  get mappedWindowType(): any {
    const id = this.projectData?.windowtype;
    if (id === undefined || id === null) return null;
    return Constants.data_windows.find((w: any) => w.id === id) ?? null;
  }

  getWindowTypeName(): string {
    if (!this.mappedWindowType?.name) return '';
    return this.translate.instant(this.mappedWindowType.name);
  }

  getWindowTypeDesc(): string {
    if (!this.mappedWindowType?.desc) return '';
    return this.translate.instant(this.mappedWindowType.desc);
  }

  hasWindowTypeDesc(): boolean {
    return this.getWindowTypeDesc().trim().length > 0;
  }

  isConfigurationSaved(): boolean {
    return !!(
      this.mappedWindowType &&
      this.projectData?.windowglas?.id !== undefined
    );
  }

  hasSpacerExpertData(): boolean {
    return !!(
      this.projectData?.spacerExpert &&
      Object.keys(this.projectData.spacerExpert).length > 0
    );
  }

  async openActionModal() {
    const modal = await this.modalController.create({
      component: ActionComponent,
      cssClass: 'configuration-modal',
      componentProps: {
        openedFrom: 'configuration'
      }
    });

    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      // console.log('Selected option:', data.selectedOption);
      await this.loadProjectData();
    }
  }

  async close() {
    // this.modalController.dismiss();
    await this.modalController.dismiss(null, 'confirm');
  }

  get showWindowTypeCard(): boolean {
    return this.allConfig || this.windowType;
  }

  get showFrameCard(): boolean {
    return this.allConfig || this.frameType;
  }

  get showGlassCard(): boolean {
    return this.allConfig || this.glassType;
  }

  get showSpacerCard(): boolean {
    return this.allConfig || this.spacerType;
  }

  get showGeorgianCard(): boolean {
    return this.allConfig || this.georgianType;
  }

  makeAllConfigInactive() {
    this.allConfig = false;
    this.windowType = false;
    this.glassType = false;
    this.frameType = false;
    this.spacerType = false;
    this.georgianType = false;
  }

  private fetchThermalResults(): void {
    if (this.isComparisonMode && !this.saveOnlyGlass) {
      this.thermalApi.calculatePsi(true).subscribe({
        next: (res) => {
          const raw = localStorage.getItem('iCaluwin-LastProject-1');
          const mainProject = raw ? JSON.parse(raw) : {};
          mainProject.psi = res.value;
          mainProject.psiUnit = res.unit;
          localStorage.setItem('iCaluwin-LastProject-1', JSON.stringify(mainProject));
          this.loadProjectData();
        }
      })
      return;
    }
    // this.isThermalLoading = true;
    if (!this.saveOnlyGlass) {
      this.thermalApi.calculateBoth().subscribe({
        next: (res) => {
          const raw = localStorage.getItem('iCaluwin-LastProject');
          const mainProject = raw ? JSON.parse(raw) : {};
          mainProject.uw = res.uw.value;
          mainProject.uwUnit = res.uw.unit;
          mainProject.psi = res.psi.value;
          mainProject.psiUnit = res.psi.unit;
          localStorage.setItem('iCaluwin-LastProject', JSON.stringify(mainProject));
          this.loadProjectData();
          // this.isThermalLoading = false;
        },
        error: (err) => {
          console.error('Thermal calculation failed:', err);
          // this.isThermalLoading = false;
        }
      });
    }
  }

  get isConfigNotSaved(): boolean {
    return this.configStatus === 'NOT_SAVED';
  }

  get isConfigHasUnsavedChanges(): boolean {
    return this.configStatus === 'UNSAVED_CHANGES';
  }

  get isConfigSaved(): boolean {
    return this.configStatus === 'SAVED';
  }

  ngOnDestroy() {
    this.configStatusSub?.unsubscribe();
  }
}
